import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { ErrorCatcher } from '../../components/ErrorCatcher';
import { FallbackErrorCatcher, FallbackErrorCatcherProps } from '../../components/ErrorCatcher/ErrorCatcher';
import { ACCOUNTS_QUERY_KEY } from '../../fetchHooks/useAccount';
import { FAVORITE_ACCOUNT_QUERY } from '../../fetchHooks/useFavoriteAccount';
import useTranslation from '../../hooks/useTranslation';
import { ACCOUNT_SERVICE_PATH } from '../../services/accountService';
import { FAVORITE_ACCOUNT_SERVICE_PATH } from '../../services/favoriteAccountService';

const FavoriteAccountErrorComponent: React.FC<FallbackErrorCatcherProps> = ({ error, resetErrorBoundary }) => {
    const { commonErrors } = useTranslation();
    if (error?.url?.includes(ACCOUNT_SERVICE_PATH)) {
        return (
            <section className="favorite-account-widget__error-wrapper">
                <Icon className="icon--36" type={IconTypes.UTROPSTEGN_36} />
                <h3 className="favorite-account-widget__error-title">{commonErrors.gettingAccountsFailed}</h3>
            </section>
        );
    }
    if (error?.url?.includes(FAVORITE_ACCOUNT_SERVICE_PATH))
        return <div className="favorite-account-widget__placeholder" />;
    return (
        <FallbackErrorCatcher
            queriesToInvalidateOnRetry={[ACCOUNTS_QUERY_KEY, FAVORITE_ACCOUNT_QUERY]}
            noBackgroundOnErrorCard
            resetErrorBoundary={resetErrorBoundary}
            error={error}
        />
    );
};

const FavoriteAccountErrorCatcher: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
        <ErrorCatcher appNamespace="favoriteaccount" fallbackComponent={FavoriteAccountErrorComponent}>
            {children}
        </ErrorCatcher>
    );
};

export default FavoriteAccountErrorCatcher;
